import { GenericObject } from "utility/misc";

import githubConfig from "./config";

// -----------------------------------------------------------------------------

export default function redirectToGithubOauthUrl(
  orgStore: GenericObject,
  navigate: Function
): void {
  const params = new URLSearchParams({
    redirect_uri: encodeURI(
      `${window.location.origin}/environment/sources/github/oauth2`
    ),
    state: orgStore.uuid,
  }).toString();
  const oauthURL = `${
    githubConfig.publicLink ?? ""
  }/installations/new?${params}`;

  //
  // nosemgrep: javascript.browser.security.open-redirect.js-open-redirect
  window.location.href = oauthURL;
}
